export default __webpack_public_path__ + "static/media/red_bin.e8ab6e03.svg";